const parseOfferData = (offerData) => {
    return {
        isNotificationCard: offerData.type === "more_offers",
        partnershipId: offerData?.partnership_id,
        icon: {
            src: offerData?.icon?.url,
            alt: offerData?.icon?.alt,
        },
        title: {
            text: offerData?.name?.text,
            color: offerData?.name?.color,
        },
        heading: {
            text: offerData?.heading?.text,
            color: offerData?.heading?.color,
        },
        subHeading: {
            text: offerData?.sub_heading?.text,
            color: offerData?.sub_heading?.color,
        },
        cta: {
            label: offerData?.cta?.label,
            gaDetails: offerData?.cta?.ga_details,
            action: offerData?.cta?.action?.toLowerCase(),
            url: offerData?.cta?.url?.web,
            functionMap: offerData?.cta?.function_map,
            disabled: offerData?.cta?.disabled,
            notificationSetLabel: offerData?.cta?.notification_set_label,
        },
        isDisabled: offerData.disabled,
        isExpired: offerData.isExpired,
    }
}

export const parseWidgetData = (response) => {
    const widgetsData = []
    const bottomSheetsData = {}
    let savingsInformation = {}
    const bottomSheetObject = response?.data?.bottom_sheets || {}
    let planId
    let cancellationImage
    let pharmacyBenefits
    let benefitsListWidget
    let PharmacyBenefitsData
    let LabsBenefitsData
    let ConsultationBenefitsData
    let OtherBenefitsData
    let additionalBenefitsHeaders
    let CODbenefitsLocked
    let carePlanCODBenefit
    const benefitsList = []

    for (const bottomSheet in bottomSheetObject) {
        switch (bottomSheet) {
            case "revised_plan_bottom_info": {
                const data = bottomSheetObject[bottomSheet]
                const bottomSheetData = {
                    header: data?.header?.text,
                    image: { url: data?.image?.url, alt: data?.image?.alt },
                    description: data?.description,
                }
                bottomSheetsData.revisedPlanInfo = bottomSheetData
                break
            }
            case "view_consultation_details": {
                const data = bottomSheetObject[bottomSheet]
                const bottomSheetData = {
                    header: data?.header?.text,
                    image: { url: data?.image },
                    list: data?.data.map((item) => {
                        return {
                            imageUrl: item?.icon?.url,
                            imageAlt: item?.icon?.alt,
                            header: item?.header?.text,
                            subHeader: item?.sub_header?.text,
                            subText: item?.sub_text?.text,
                            status: { ...item?.status, hexCode: item?.status?.color },
                            ctaList: item?.ctas?.map((item) => {
                                return {
                                    ...item,
                                    redirectionUrl: item?.url?.web,
                                    download: item.download || true,
                                    gaDetails: item?.ga_details,
                                }
                            }),
                        }
                    }),
                }
                bottomSheetsData.bookedConsults = bottomSheetData
                break
            }
            case "view_lab_details": {
                const data = bottomSheetObject[bottomSheet]
                const bottomSheetData = {
                    header: data?.header?.text,
                    image: { url: data?.image },
                    list: data?.data.map((item) => {
                        return {
                            imageUrl: item?.icon?.url,
                            imageAlt: item?.icon?.alt,
                            header: item?.header?.text,
                            subHeader: item?.sub_header?.text,
                            subText: item?.sub_text?.text,
                            status: { ...item?.status, hexCode: item?.status?.color },
                            ctaList: item?.ctas?.map((item) => {
                                return {
                                    ...item,
                                    redirectionUrl: item?.url?.web,
                                    download: item.download || true,
                                    gaDetails: item?.ga_details,
                                }
                            }),
                        }
                    }),
                }
                bottomSheetsData.bookedLabTests = bottomSheetData
                break
            }
            case "membership_details":
                {
                    const data = bottomSheetObject[bottomSheet]
                    const bottomSheetData = {
                        header: data?.header?.text,
                        listContents: data?.details?.map?.((item) => {
                            return { name: item?.label, description: item?.value }
                        }),
                        listBackgroundColor: "#FEF7EF",
                        imagesUrl: data?.data.map((item) => {
                            return { medium: item?.url, altText: item?.alt }
                        }),
                        GADetails: data?.ga_details,
                        closeGADetails: data?.close_ga_details,
                    }
                    bottomSheetsData.membershipDetails = bottomSheetData
                }
                break
            case "successful_cancellation":
                {
                    const data = bottomSheetObject[bottomSheet]
                    const bottomSheetData = {
                        header: data?.header?.text,
                        description: data?.description?.text,
                        subText: data?.cta?.sub_text,
                        icon: data?.icon?.url,
                        primaryActionLabel: data?.cta?.label,
                        url: data?.cta?.url,
                        onCancelSuccessGA: data?.cta?.ga_details,
                    }
                    bottomSheetsData.CancellationSuccess = bottomSheetData
                }
                break
            case "cancel_bottomsheet_confirm_info":
                {
                    const data = bottomSheetObject[bottomSheet]
                    const bottomSheetData = {
                        header: data?.heading,
                        subHeading: data?.sub_heading,
                        primaryCta: {
                            label: data?.primary_cta?.label,
                            functionMap: data?.primary_cta?.funtion_map,
                            gaDetails: data?.primary_cta?.ga_details,
                        },
                        secondaryCta: {
                            label: data?.secondary_cta?.label,
                            functionMap: data?.secondary_cta?.function_map,
                            gaDetails: data?.secondary_cta?.ga_details,
                        },
                        subText: data?.sub_text,
                    }
                    bottomSheetsData.confirmCancellation = bottomSheetData
                }
                break
            case "cancel_membership_bottom_info":
                {
                    const data = bottomSheetObject[bottomSheet]
                    const bottomSheetData = {
                        header: data?.sub_header?.text,
                        subHeader: data?.description?.text,
                        cta: {
                            label: data?.cta?.label,
                            functionMap: data?.cta?.function_map,
                            gaDetails: data?.cta?.ga_details,
                        },
                        dropdownName: "Reason for cancellation",
                        dropdownLabel: "Reason for cancellation",
                        dropdownOptions: data?.reasons?.map((option) => {
                            return {
                                id: option?.id,
                                label: option?.reason,
                                value: option?.reason,
                            }
                        }),
                        subText: data?.bottom_text,
                    }
                    bottomSheetsData.reasonForCancellation = bottomSheetData
                    planId = data?.plan_id
                }
                break
            case "book_lab_test": {
                const labData = bottomSheetObject[bottomSheet]
                const bottomSheetData = {
                    placeholderData: {
                        image: {
                            url: labData?.placeholder_data?.image?.url,
                            alt: labData?.placeholder_data?.image?.alt,
                        },
                        heading: labData?.placeholder_data?.heading,
                        subHeading: labData?.placeholder_data?.sub_heading,
                        cta: {
                            label: labData?.placeholder_data?.cta?.label,
                            url: labData?.placeholder_data?.cta?.url?.web,
                            gaDetails: labData?.placeholder_data?.cta?.ga_details,
                        },
                    },
                    header: {
                        primary: labData?.header?.text,
                        secondary: "Test details",
                    },
                    subText: labData?.sub_text,
                    primaryActionLabel: labData.cta_label,
                    listOfTests: labData?.data?.map((test) => {
                        return {
                            header: test?.header?.text,
                            price: {
                                price: test?.price,
                                discountedPrice: test?.discounted_price,
                            },
                            subtext: test?.sub_header?.text,
                            description: test?.description?.text,
                            primaryLabel: test?.cta?.label,
                            secondaryLabel: "view test details",
                            url: test?.proceed_cta?.url,
                            testDetails: {
                                header: test?.test_details?.header?.text,
                                price: {
                                    price: test?.test_details?.price,
                                    discountedPrice: test?.test_details?.discounted_price,
                                },
                                subText: test?.test_details?.sub_header?.text,
                                description: {
                                    text: test?.test_details?.description?.text,
                                    backgroundColor: test?.test_details?.description?.bg_color,
                                },
                                listOfItems: test?.test_details?.tests?.map((item) => {
                                    return {
                                        type: item?.type,
                                        header: item?.text,
                                        subtext: item?.subtext?.text,
                                        parameters: item?.data,
                                    }
                                }),
                            },
                            cta: { ...test?.cta, gaDetails: test?.cta?.ga_details },
                            proceedCta: { gaDetails: test?.proceed_cta?.ga_details, ...test?.proceed_cta },
                            onExpandCta: { gaDetails: test?.test_info_expand_ga_details },
                            onScrollCta: { gaDetails: test?.test_info_scroll_ga_details },
                            isTestFeasible: true,
                        }
                    }),
                }
                bottomSheetsData.bookLabTest = bottomSheetData
            }
        }
    }

    response?.data?.data?.map((widget) => {
        switch (widget.type) {
            case "partnership_offers": {
                const widgetData = {
                    logo: {
                        src: widget?.header?.logo?.url,
                        alt: widget?.header?.logo?.alt,
                    },
                    title: {
                        text: widget?.header?.title?.text,
                        color: widget?.header?.title?.bg_color,
                    },
                    cta: {
                        label: widget?.header?.cta?.label,
                        icon: {
                            src: widget?.header?.cta?.icon?.url,
                            alt: widget?.header?.cta?.icon?.alt,
                        },
                        gaDetails: widget?.header?.cta?.ga_details,
                        action: widget?.header?.cta?.action?.toLowerCase(),
                        url: widget?.header?.cta?.url?.web,
                    },
                    backgroundGradient: widget?.bg_gradient,
                    offers: widget?.partnership_cards.map((offerData) => {
                        if (offerData.type === "dummy_card") {
                            return {
                                isDummy: true,
                                cta: {
                                    label: offerData?.cta?.label,
                                    gaDetails: offerData?.cta?.ga_details,
                                    icon: {
                                        src: offerData?.cta?.icon?.url,
                                        alt: offerData?.cta?.icon?.alt,
                                    },
                                    action: offerData?.cta?.action?.toLowerCase(),
                                    url: offerData?.cta?.url?.web,
                                },
                                isDisabled: offerData.disabled,
                            }
                        } else {
                            return parseOfferData(offerData)
                        }
                    }),
                }
                widgetsData[5] = { type: "partnerOffers", widgetData: widgetData }
                break
            }
            case "membership_status":
                {
                    savingsInformation = {
                        description: widget?.description?.text?.text,
                        ...savingsInformation,
                    }
                }
                break
            case "membership_info":
                {
                    const widgetData = {
                        heading: {
                            prefixText: widget?.header?.prefix_text,
                            image: { url: widget?.header?.image?.url, alt: widget?.header?.image?.alt },
                            postfixText: widget?.header?.suffix_text,
                        },
                        savingsCardRight: {
                            heading: widget?.status_info?.text,
                            subHeading: widget?.status_info?.day,
                            subHeadingColor: widget?.status_info?.color,
                            description: widget?.status_info?.subtext,
                        },
                        bgGradient: widget?.bg_gradient,
                        cta: {
                            label: widget?.cta?.label,
                            functionMap: widget?.cta?.function_map,
                            gaDetails: widget?.cta?.ga_details,
                        },
                        bgImage: widget?.bg_image,
                        savingsImage: widget?.image?.url,
                    }

                    const actionBarData = {
                        backgroundColor: widget?.description?.bg_color,
                        text: widget?.description?.text,
                        textColor: widget?.description?.color,
                    }

                    savingsInformation = { ...savingsInformation, ...widgetData }
                    if (actionBarData?.text) {
                        widgetsData[1] = { type: "actionBar", widgetData: actionBarData }
                    }
                }
                break
            case "cod_benefit":
                carePlanCODBenefit = widget
                widgetsData[3] = { type: "codBenefit", widgetData: carePlanCODBenefit }

                break
            case "benefits":
                PharmacyBenefitsData = []
                LabsBenefitsData = []
                ConsultationBenefitsData = []
                OtherBenefitsData = []
                additionalBenefitsHeaders = widget?.header_additional_benefits
                CODbenefitsLocked = widget?.benefits_locked
                widget?.data?.forEach((item) => {
                    switch (item?.type) {
                        case "exclusive_offer":
                            OtherBenefitsData.push(item)
                            break
                        case "lab_neucoins":
                            LabsBenefitsData.push(item)
                            break
                        case "coupon_savings":
                            PharmacyBenefitsData.push(item)
                            break
                        case "neu_coins":
                            PharmacyBenefitsData.push(item)
                            break
                        case "free_shippings":
                            PharmacyBenefitsData.push(item)
                            break
                        case "rapid_savings":
                            PharmacyBenefitsData.push(item)
                            break
                        case "quick_processing":
                            PharmacyBenefitsData.push(item)
                            break
                        case "lab_savings":
                            LabsBenefitsData.push(item)

                            break
                        case "consultation_neucoins":
                            ConsultationBenefitsData.push(item)
                            break
                        case "doctor_consultations":
                            ConsultationBenefitsData.push(item)

                            break
                        case "premium_support":
                            OtherBenefitsData.push(item)
                            break
                        case "early_sale":
                            OtherBenefitsData.push(item)
                            break
                        case "user_benefit": {
                            const list = []
                            if (item?.header_pharmacy) {
                                list.push({
                                    heading: item?.header_pharmacy?.text,
                                    subText: item?.times_remaining_pharmacy,
                                    description: item?.subtext_pharmacy,
                                    primaryCta: {
                                        label: item?.cta_pharmacy?.label,
                                        functionMap: item?.cta_pharmacy?.function_map,
                                        url: item?.cta_pharmacy?.url?.web,
                                        disabled: item?.cta_pharmacy?.disabled,
                                        gaDetails: item?.cta_pharmacy?.ga_details,
                                    },
                                    image: { url: item?.icon_pharmacy?.url },
                                    underlinedCta: {
                                        label: item?.underlined_cta_pharmacy?.label,
                                        functionMap: item?.underlined_cta_pharmacy?.function_map,
                                        url: item?.underlined_cta_pharmacy?.url?.web,
                                        gaDetails: item?.underlined_cta_pharmacy?.ga_details,
                                    },
                                })
                            }

                            if (item?.header_consult) {
                                list.push({
                                    heading: item?.header_consult?.text,
                                    subText: item?.times_remaining_consultation,
                                    description: item?.subtext_consult,
                                    primaryCta: {
                                        label: item?.cta_consult?.label,
                                        functionMap: item?.cta_consult?.function_map,
                                        url: item?.cta_consult?.url?.web,
                                        disabled: item?.cta_consult?.disabled,
                                        gaDetails: item?.cta_consult?.ga_details,
                                    },
                                    image: { url: item?.icon_consult?.url },
                                    underlinedCta: {
                                        label: item?.underlined_cta_consultation?.label,
                                        functionMap: item?.underlined_cta_consultation?.function_map,
                                        url: item?.underlined_cta_consultation?.url?.web,
                                        gaDetails: item?.underlined_cta_consultation?.ga_details,
                                    },
                                })
                            }

                            if (item?.header_lab) {
                                list.push({
                                    heading: item?.header_lab?.text,
                                    subText: item?.times_remaining_lab,
                                    description: item?.subtext_lab,
                                    primaryCta: {
                                        label: item?.cta_lab?.label,
                                        functionMap: item?.cta_lab?.function_map,
                                        url: item?.cta_lab?.url?.web,
                                        disabled: item?.cta_lab?.disabled,
                                        gaDetails: item?.cta_lab?.ga_details,
                                    },
                                    image: { url: item?.icon_lab?.url },
                                    underlinedCta: {
                                        label: item?.underlined_cta_labs?.label,
                                        functionMap: item?.underlined_cta_labs?.function_map,
                                        url: item?.underlined_cta_labs?.url?.web,
                                        gaDetails: item?.underlined_cta_labs?.ga_details,
                                    },
                                })
                            }

                            const useYourBenefits = {
                                heading: widget?.header?.text,
                                list,
                            }
                            widgetsData[4] = { type: "useYourBenefits", widgetData: useYourBenefits }
                        }
                    }
                })

                pharmacyBenefits = {
                    widgetHeading: additionalBenefitsHeaders?.header,
                    heading: additionalBenefitsHeaders?.header_pharmacy,
                    CODbenefitsLocked,
                    listOfItems: PharmacyBenefitsData?.map((card) => {
                        return {
                            heading: card?.header?.text,
                            subText: card?.subtext?.text,
                            description: card?.description?.text,
                            image: {
                                url: card?.image?.url || card?.image || card?.icon?.url,
                                alt: "benefits image",
                                width: "192px",
                                height: "192px",
                            },
                            status: card?.subText?.text,
                        }
                    }),
                    primaryCta: !PharmacyBenefitsData[0]?.cta?.disabled && {
                        label: PharmacyBenefitsData?.[0]?.cta?.label,
                        url: PharmacyBenefitsData?.[0]?.cta?.url?.web,
                        gaDetails: PharmacyBenefitsData?.[0]?.cta?.ga_details_additional_benefits,
                    },
                }
                if (additionalBenefitsHeaders?.header_consultation) {
                    benefitsList.push({
                        heading: additionalBenefitsHeaders?.header_consultation,
                        headingColor: "#8A2422",
                        cards: ConsultationBenefitsData?.map?.((card) => {
                            return {
                                heading: card?.header?.text,
                                subHeading: card?.subtext?.text,
                                subHeadingColor: card?.subtext?.color,
                                description: card?.description?.text,
                                image: {
                                    url: card?.image?.url,
                                    alt: card?.image?.alt,
                                },
                                activityBox: {
                                    backgroundColor: card?.usage_details?.bg_color,
                                    text: card?.usage_details?.text,
                                    ctaLabel:
                                        card?.usage_details?.cta?.label || card?.usage_details?.text
                                            ? "View"
                                            : null,
                                    isDisabled:
                                        card?.usage_details?.cta?.disabled || card?.usage_details?.text
                                            ? "view_consultation_details"
                                            : null,
                                    functionMap: card?.usage_details?.cta?.function_map,
                                    action: card?.usage_details?.cta?.function_map,
                                    gaDetails: card?.usage_details?.cta?.ga_details,
                                },
                            }
                        }),
                        primaryCta: !ConsultationBenefitsData[0]?.cta?.disabled &&
                            ConsultationBenefitsData[0]?.cta?.label && {
                                url: ConsultationBenefitsData[0]?.cta?.url?.web,
                                label: ConsultationBenefitsData[0]?.cta?.label,
                                functionMap: ConsultationBenefitsData[0]?.cta?.function_map,
                                isOutlined: ConsultationBenefitsData[0]?.cta?.type === "outlined",
                                action: ConsultationBenefitsData[0]?.cta?.action,
                                disabled: ConsultationBenefitsData[0]?.cta?.disabled,
                                gaDetails: ConsultationBenefitsData[0]?.ga_details_additional_benefits,
                            },
                    })
                }
                if (additionalBenefitsHeaders?.header_labs) {
                    benefitsList.push({
                        heading: additionalBenefitsHeaders?.header_labs,
                        headingColor: "#8A2422",
                        cards: LabsBenefitsData?.map((card) => {
                            return {
                                heading: card?.header?.text,
                                subHeading: card?.subtext?.text,
                                subHeadingColor: card?.subtext?.color,
                                status: card?.subText?.text,
                                description: card?.description?.text,
                                image: {
                                    url: card?.image?.url,
                                    alt: card?.image?.alt,
                                },
                                activityBox: {
                                    backgroundColor: card?.usage_details?.bg_color,
                                    text: card?.usage_details?.text,
                                    ctaLabel: card?.usage_details?.cta?.label,
                                    isDisabled: card?.usage_details?.cta?.disabled,
                                    functionMap: card?.usage_details?.cta?.function_map,
                                    action: card?.usage_details?.cta?.function_map,
                                    gaDetails: card?.usage_details?.cta?.ga_details,
                                },
                            }
                        }),
                        primaryCta: !LabsBenefitsData[0]?.cta?.disabled &&
                            LabsBenefitsData[0]?.cta?.label && {
                                url: LabsBenefitsData[0]?.cta?.url?.web,
                                label: LabsBenefitsData[0]?.cta?.label,
                                functionMap: LabsBenefitsData[0]?.cta?.function_map,
                                isOutlined: LabsBenefitsData[0]?.cta?.type === "outlined",
                                action: LabsBenefitsData[0]?.cta?.action,
                                disabled: LabsBenefitsData[0]?.cta?.disabled,
                                gaDetails: LabsBenefitsData[0]?.cta?.ga_details,
                            },
                    })
                }
                if (additionalBenefitsHeaders?.header_other_benefits) {
                    benefitsList.push({
                        heading: additionalBenefitsHeaders?.header_other_benefits,
                        headingColor: "#8A2422",
                        isOtherBenefit: true,
                        cards: OtherBenefitsData?.map((card) => {
                            return {
                                type: card?.type,
                                heading: card?.header?.text,
                                subHeading: card?.subtext?.text,
                                subHeadingColor: card?.subtext?.color,
                                description: card?.description?.text,
                                image: {
                                    url: card?.image?.url,
                                    alt: card?.image?.alt,
                                    width: "200px",
                                    height: "160px",
                                },
                                activityBox: {
                                    backgroundColor: card?.usage_details?.bg_color,
                                    text: card?.usage_details?.text,
                                    ctaLabel: card?.usage_details?.cta?.label,
                                    isDisabled: card?.usage_details?.cta?.disabled,
                                    functionMap: card?.usage_details?.cta?.function_map,
                                    action: card?.usage_details?.cta?.function_map,
                                    GADetails: card?.usage_details?.cta?.ga_details,
                                },
                                cardCta: card?.cta?.label
                                    ? {
                                          label: card?.cta?.label,
                                          type: "secondary",
                                          url: card?.cta?.url?.web,
                                          disabled: card?.cta?.disabled,
                                          gaDetails: card?.cta?.ga_details,
                                          functionMap:
                                              card?.cta?.function_map ||
                                              (card?.type === "early_sale" && "remind_me"),
                                      }
                                    : null,
                            }
                        }),
                    })
                }
                benefitsListWidget = {
                    widgetHeading: additionalBenefitsHeaders?.header,
                    CODbenefitsLocked,
                    benefitsList,
                }

                widgetsData[6] = { type: "pharmacyBenefits", widgetData: pharmacyBenefits }
                widgetsData[7] = { type: "benefitsList", widgetData: benefitsListWidget }

                break
            case "cancel_membership":
                {
                    const widgetData = {
                        cta: {
                            ...widget?.cta,
                            functionMap: "cancel_bottomsheet_confirm_info",
                            gaDetails: widget?.cta?.ga_details,
                        },
                    }
                    widgetsData[10] = { type: "cancellationWidget", widgetData }
                    cancellationImage = widget?.cta?.image
                }
                break
            case "savings":
                {
                    const widgetData = {
                        savingsCardLeft: {
                            heading: widget?.header?.text,
                            amount: widget?.header_subtext,
                            icon: widget?.image?.url,
                            description: widget?.subtext?.text,
                        },
                    }
                    savingsInformation = { ...savingsInformation, ...widgetData }
                }
                break
            case "faqs":
                {
                    const widgetData = {
                        header: widget?.header?.text,
                        data: widget?.data.map((item) => {
                            return { label: item.title, responses: [{ displayText: item.content }] }
                        }),
                        cta: { ...widget?.cta, gaDetails: widget?.cta?.ga_details },
                        functionMap: widget?.cta?.function_map,
                    }
                    widgetsData[8] = { type: "faqWidget", widgetData }
                }
                break
            case "early_renew": {
                const widgetData = {
                    header: widget?.header?.text,
                    subText: widget?.subtext,
                    listItems: widget?.data,
                    cta: {
                        label: widget?.cta?.label,
                        gaDetails: widget?.cta?.ga_details,
                        url: widget?.cta?.url,
                    },
                    renewMembershipLabel: widget?.cta?.renew_label,
                    bgColor: widget?.bg_color,
                    image: { url: widget?.image?.url, alt: widget?.image?.alt },
                    revisedPlanInfo: {
                        text: widget?.revised_plan_info?.text,
                        cta: {
                            url: widget?.revised_plan_info?.url,
                        },
                        image: {
                            url: widget?.revised_plan_info?.cta?.icon?.url,
                            alt: widget?.revised_plan_info?.cta?.icon?.alt,
                        },
                        GADetails: widget?.revised_plan_info?.cta?.ga_details,
                        isDisabled: widget?.revised_plan_info?.cta?.disabled,
                        functionMap: widget?.revised_plan_info?.cta?.function_map,
                        action: widget?.revised_plan_info?.cta?.action,
                    },
                }
                widgetsData[9] = { type: "renewWidget", widgetData }
                widgetsData[2] = { type: "renewInformationWidget", widgetData }

                break
            }
        }
    })
    if (Object.keys(savingsInformation)?.length > 0) {
        widgetsData[0] = { type: "savingsInformation", widgetData: savingsInformation }
    }

    const onPageLoadGA = response?.data?.ga_details

    return {
        widgets: widgetsData,
        bottomSheets: bottomSheetsData,
        onPageLoadGA,
        planId,
        cancellationImage,
        meta_data: response?.data?.meta_data,
    }
}
